import { MessageCircle } from 'lucide-react';

export default function EmptyState({
  title,
  copy,
  action,
}: {
  title: string;
  copy: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex h-full min-h-[280px] flex-col items-center justify-center px-6 text-center">
      <div className="mb-5 grid h-16 w-16 place-items-center rounded-xl border border-white/10 bg-white/[0.04] text-relay-cyan">
        <MessageCircle size={28} />
      </div>
      <h2 className="text-lg font-semibold text-white">{title}</h2>
      <p className="mt-2 max-w-md text-sm leading-6 text-slate-400">{copy}</p>
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

